(ns heraldicon.heraldry.escutcheon
  (:require
   [heraldicon.heraldry.field.environment :as environment]
   [heraldicon.localization.string :as string]
   [heraldicon.math.bounding-box :as bb]
   [heraldicon.math.vector :as v]
   [heraldicon.options :as options]
   [heraldicon.svg.path :as path]))

(def ^:private heraldicon-attribution
  {:nature :own-work
   :license :public-domain
   :creator-name "Heraldicon"
   :creator-link "https://heraldicon.org"})

(def ^:private heater
  {;; sqrt(3) / 2 * 6 ~ 5.196152422706632
   :shape (str "m 0,0"
               "h 3"
               "v 2"
               "a 6 6 0 0 1 -3,5.196152422706632"
               "a 6 6 0 0 1 -3,-5.196152422706632"
               "v -2"
               "z")

   ::name :string.escutcheon.type/heater
   ::attribution heraldicon-attribution})

(def ^:private square-french
  {:shape (str "m 0,0"
               "v 15.7"
               "c 0,6 6,12 12,13"
               "c 6,-1 12,-7 12,-13"
               "V 0"
               "z")

   ::name :string.escutcheon.type/square-french
   ::attribution heraldicon-attribution})

(def ^:private square-iberian
  {:shape (str "m 0,0"
               "h 5"
               "v 7"
               "a 5 5 0 0 1 -10,0"
               "v -7"
               "z")

   ::name :string.escutcheon.type/square-iberian
   ::attribution heraldicon-attribution})

(def ^:private square-czech
  {;; diff(sqrt(r*r - x*x))
   ;; solve(-24/sqrt(r^2 - 24^2) - (-35/4)) ~ 24.156226
   :shape (str "m 0,0"
               "h 56"
               "l -4,35"
               "a 24.156226 24.156226 0 0 1 -48,0"
               "z")

   ::name :string.escutcheon.type/square-czech
   ::attribution heraldicon-attribution})

(def ^:private french-modern
  {:shape (str "m 0,0"
               "h 7"
               "v 15"
               "a 1 1 0 0 1 -1,1"
               "h -5"
               "a 1 1 0 0 0 -1,1"
               "a 1 1 0 0 0 -1,-1"
               "h -5"
               "a 1 1 0 0 1 -1,-1"
               "v -15"
               "h 7"
               "z")
   :bounding-box (bb/BoundingBox. -7 7 0 16)
   :center-fess? true

   ::name :string.escutcheon.type/french-modern
   ::attribution heraldicon-attribution})

(def ^:private lozenge
  {:shape (str "m 0,0"
               "L 5,6.5"
               "L 0,13"
               "L -5,6.5"
               "z")
   :center-fess? true

   ::name :string.escutcheon.type/lozenge
   ::attribution heraldicon-attribution})

(def ^:private oval
  {:shape (str "m 0,0"
               "A 5 6.8 0 0 1 5,6.5"
               "A 5 6.8 0 0 1 0,13"
               "A 5 6.8 0 0 1 -5,6.5"
               "A 5 6.8 0 0 1 0,0"
               "z")
   :center-fess? true

   ::name :string.escutcheon.type/oval
   ::attribution heraldicon-attribution})

(def ^:private roundel
  {:shape (str "m 0,0"
               "a 5 5 0 0 1 0,10"
               "a 5 5 0 0 1 0,-10"
               "z")
   :center-fess? true

   ::name :string.escutcheon.type/roundel
   ::attribution heraldicon-attribution})

(def ^:private swiss
  {;; sqrt(3) / 2 * 6 ~ 5.196152422706632
   :shape (str "m 0,0"
               "a 6 6 0 0 0 3,0"
               "v 2"
               "a 6 6 0 0 1 -3,5.196152422706632"
               "a 6 6 0 0 1 -3,-5.196152422706632"
               "v -2"
               "a 6 6 0 0 0 3,0"
               "z")

   ::name :string.escutcheon.type/swiss
   ::attribution heraldicon-attribution})

(def ^:private english
  {:shape (str "m 0,0"
               "h 8"
               "a 1 1 0 0 0 -1,1"
               "v 14"
               "a 1 1 0 0 1 -1,1"
               "h -5"
               "a 1 1 0 0 0 -1,1"
               "a 1 1 0 0 0 -1,-1"
               "h -5"
               "a 1 1 0 0 1 -1,-1"
               "v -14"
               "a 1 1 0 0 0 -1,-1"
               "h 8"
               "z")
   :bounding-box (bb/BoundingBox. -7 7 0 16)
   :center-fess? true

   ::name :string.escutcheon.type/english
   ::attribution heraldicon-attribution})

(def ^:private polish
  {:shape "m 43.402145,5e-7
           c -8.662508,0 -14.063932,7.322064 -27.53457,9.380727 0.01086,7.9371285
           -3.321499,15.7448405 -7.7644202,20.8881635 0,0 8.6550412,4.035941
           8.6550412,12.967045 0,13.48538 -14.3402146,13.50873 -14.3402146,13.50873
           0,0 -2.4179809,4.962539 -2.4179809,15.009696 0,22.996861
           15.7236635,40.377428 27.6621895,45.737558 11.938525,5.36013
           18.80961,7.63894 22.359194,12.50808 3.549585,-4.86914 10.377904,-7.14795
           22.316426,-12.50808 11.938526,-5.36013 27.662185,-22.742701
           27.662185,-45.737557 0,-10.047158 -2.41798,-15.009697
           -2.41798,-15.009697 0,0 -14.340209,-0.02335 -14.340209,-13.50873
           0,-8.931104 8.655042,-12.967045 8.655042,-12.967045
           C 87.453242,25.123567 84.122242,17.317856 84.132428,9.3807275
           70.661111,7.3213975 65.259687,5.0000001e-7 56.597858,5.0000001e-7
           51.658715,5.0000001e-7 50.021384,2.5016165 50.021384,2.5016165
           c 0,0 -1.680096,-2.50161599999999 -6.619239,-2.501616 z"
   :bounding-box (bb/BoundingBox. 0 100 2.5016165 130)

   ::name :string.escutcheon.type/polish
   ::attribution (merge heraldicon-attribution
                        {:nature :derivative
                         :source-license :public-domain
                         :source-link "https://commons.wikimedia.org/wiki/File:Polish_Escutcheon.svg"
                         :source-name "Polish Escutcheon"
                         :source-creator-name "Masur"
                         :source-creator-link "https://commons.wikimedia.org/wiki/User:Masur"})})

(def ^:private polish-19th-century
  {:shape "M 9.5659013,0 0,9.9320525 C 13.878078,26.565127 6.4209004,51.856025 6.038075,76.190404
           5.7054978,97.330757 24.490898,120 49.999999,120 75.509101,120 94.294503,97.330757 93.961926,76.190404
           93.579101,51.856025 86.121923,26.565128 100,9.9320525 L 90.434099,0
           C 81.097132,12.169832 64.97276,3.8094077 49.999999,3.8094077
           35.027237,3.8094077 18.90287,12.169832 9.5659013,0 Z"
   :bounding-box (bb/BoundingBox. 0 100 0.3 120)

   ::name :string.escutcheon.type/polish-19th-century
   ::attribution (merge heraldicon-attribution
                        {:nature :derivative
                         :source-license :public-domain
                         :source-link "https://commons.wikimedia.org/wiki/File:HerbTarczaPL_XIXc.svg"
                         :source-name "HerbTarczaPL XIXc"
                         :source-creator-name "NalesnikLD"
                         :source-creator-link "https://commons.wikimedia.org/wiki/User:NalesnikLD"})})

(def ^:private renaissance
  {:shape "M 43.672061,112.35743 C 20.076921,107.21428 1.2267205,96.616647 5.1084778e-7,62.761658
           9.9757105,57.299078 13.336031,27.805689 3.0804505,12.948849 l 5.98179,-9.3387997
           C 28.967341,6.8985193 35.708501,-4.5443607 50,2.1304593 c 14.2915,-6.67482
           21.03266,4.76806 40.93775,1.47959 l 5.9818,9.3387997 C 86.66397,27.805689 90.02428,57.299078
           100,62.761658 98.77327,96.616647 79.92307,107.21428 56.32792,112.35743 51.60688,113.38653
           51.68278,114.71878 50,117 c -1.68279,-2.28122 -1.60689,-3.61347 -6.327939,-4.64257 z"
   :bounding-box (bb/BoundingBox. 0 100 2.1304593 113)

   ::name :string.escutcheon.type/renaissance
   ::attribution (merge heraldicon-attribution
                        {:nature :derivative
                         :source-license :public-domain
                         :source-link "https://commons.wikimedia.org/wiki/File:Coa_Illustration_Shield_Renaissance_7.svg"
                         :source-name "Coa Illustration Shield Renaissance 7"
                         :source-creator-name "Doc Taxon"
                         :source-creator-link "https://commons.wikimedia.org/wiki/User:Doc_Taxon"})})

(def ^:private rectangle
  {:shape "M 0,0 h 10 v 12 h -10 z"
   :center-fess? true

   ::name :string.escutcheon.type/rectangle
   ::attribution heraldicon-attribution})

(def ^:private flag
  {:function (fn [width height swallow-tail tail-point-height tail-tongue]
               (let [swallow-tail-point-dx (-> width (* swallow-tail) (/ 100))
                     dy (-> height (* tail-point-height) (/ 100))
                     half-dy (/ dy 2)
                     swallow-tail-point-top-dist (-> (/ height 2)
                                                     (- half-dy))
                     tail-tongue-point-dx (-> swallow-tail-point-dx
                                              (* tail-tongue)
                                              (/ 100))]
                 {:shape (str
                          "M 0,0"
                          "h " width
                          "l " (- swallow-tail-point-dx) ", " swallow-tail-point-top-dist
                          "l " tail-tongue-point-dx ", " half-dy
                          "l " (- tail-tongue-point-dx) ", " half-dy
                          "l " swallow-tail-point-dx ", " swallow-tail-point-top-dist
                          "h " (- width)
                          "z")
                  :bounding-box (bb/BoundingBox. 0 width 0 height)
                  :points {:fess (v/Vector. (/ width 2) (/ height 2))}}))
   :shape "M 0,0 h 5 v 3 h -5 z"
   :center-fess? true

   ::name :string.escutcheon.type/flag
   ::attribution heraldicon-attribution})

(def ^:private wedge
  {;; sqrt(3) / 2 * 6 + 2 ~ 7.196152422706632
   :shape (let [height 7.196152422706632
                hole-x 1
                hole-y 0.75]
            (str "m 0,0"
                 "h 2"
                 "a " hole-x " " hole-y " 0 0 0 " hole-x "," hole-y
                 "a 8 8 0 0 1 -3," (- height hole-y)
                 "a 8 8 0 0 1 -3," (- (- height hole-y))
                 "a " hole-x " " hole-y " 0 0 0 " hole-x "," (- hole-y)
                 "z"))

   ::name :string.escutcheon.type/wedge
   ::attribution heraldicon-attribution})

(def ^:private kite
  (let [width 1
        height 2
        half-width (/ width 2)
        dx (- half-width (/ half-width 50))
        dy (-> (* half-width
                  half-width)
               (- (* dx dx))
               Math/sqrt)
        R (-> (/ 1 4)
              (+ (* (/ (- height half-width) width)
                    (/ (- height half-width) width)))
              (* width)
              ;; this factor is guessed, based on the 50 above, they
              ;; result in roughly a curve that seems to have no corner
              (* 2))]
    {:shape (str "m 0,0"
                 "a " half-width " " half-width " 0 0 1 " dx " " (+ half-width dy)
                 "a " R " " R " 0 0 1 " (- dx) " " (- height half-width dy)
                 "a " R " " R " 0 0 1 " (- dx) " " (- (- height half-width dy))
                 "a " half-width " " half-width " 0 0 1 " dx " " (- (+ half-width dy))
                 "z")
     :points {:fess (v/Vector. 0 half-width)}

     ::name :string.escutcheon.type/kite
     ::attribution (merge heraldicon-attribution
                          {:nature :derivative
                           :source-license :public-domain
                           :source-link "https://commons.wikimedia.org/wiki/File:Kite_shield.svg"
                           :source-name "Kite shield"
                           :source-creator-name "Perhelion"
                           :source-creator-link "https://commons.wikimedia.org/wiki/User:Perhelion"})}))

(def ^:private norman
  (let [width 5
        height 8
        half-width (/ width 2)
        R (-> (/ 1 4)
              (+ (* (/ height width)
                    (/ height width)))
              (* width))]
    {:shape (str "m 0,0"
                 "h " half-width
                 "a " R " " R " 0 0 1 " (- half-width) " " height
                 "a " R " " R " 0 0 1 " (- half-width) " " (- height)
                 "z")

     ::name :string.escutcheon.type/norman-late
     ::attribution heraldicon-attribution}))

(def ^:private norman-rounded
  (let [width 5
        height 8
        d (/ height 15)
        half-width (/ width 2)
        r (-> (* d d)
              (+ (* half-width half-width))
              (/ 2 d))
        R (-> (/ 1 4)
              (+ (* (/ (- height d) width)
                    (/ (- height d) width)))
              (* width))]
    {:shape (str "m 0,0"
                 "a " r " " r " 0 0 1 " half-width " " d
                 "a " R " " R " 0 0 1 " (- half-width) " " (- height d)
                 "a " R " " R " 0 0 1 " (- half-width) " " (- (- height d))
                 "a " r " " r " 0 0 1 " half-width " " (- d)
                 "z")
     :bounding-box (bb/BoundingBox. (- half-width) half-width d height)

     ::name :string.escutcheon.type/rounded-norman-late
     ::attribution heraldicon-attribution}))

(def ^:private community-square-iberian-engrailed
  {:shape "M 0,0
           a 250,250 0 0 0 250,0
           a 250,250 0 0 0 250,0
           v 350
           a 250,250 0 0 1 -250,250
           a 250,250 0 0 1 -250,-250
           z"
   :bounding-box (bb/BoundingBox. 0 500 33.333333 600)

   ::name "Square Iberian Engrailed"
   ::attribution (merge heraldicon-attribution
                        {:nature :derivative
                         :source-license :public-domain
                         :source-link "https://heraldicon.org"
                         :source-name "Square Iberian Engrailed"
                         :source-creator-name "coinageFission#1205"
                         :source-creator-link "https://discord.com/channels/272117928298676225/272117928298676225"})})

(def ^:private community-pointy-iberian-engrailed
  {:shape "m 0,0
           v 70
           c -0.125,20 5,40 30,45 20,5 20,10 20,10 0,0 0,-5 20,-10 25,-5 30,-25 30,-45
           V 0
           C 100,0 90,5 75,5 60,5 50,0 50,0 50,0 40,5 25,5 10,5 0,0 0,0
           Z"

   ::name "Pointy Iberian Engrailed"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-kalasag
  {:shape "M 54.303084,263.03992 c 0.481806,0.77857 13.294025,21.48369
           13.294025,21.48369 1.495301,2.41641 21.449132,2.28517
           20.298782,-2.22508 C 81.70257,258.01944 90.593797,199.39078
           91.918145,151.87564 93.242492,104.35792 89.3215,28.973867
           100,9.0516574 L 90.936994,0 76.58444,13.160936 C
           96.580416,49.516131 39.329083,48.993572 59.995667,12.50895 L
           50,2.5406234 40.004333,12.50895 C 60.670917,48.993624
           3.4195838,49.516182 23.41556,13.160936 L 9.0630062,0
           0,9.0516574 C 10.678139,28.974383 6.7571471,104.35534
           8.0818554,151.87564 c 1.3243472,47.51772 10.2154196,106.14689
           4.0222536,130.42289 -1.150505,4.51025 18.803326,4.64149
           20.298782,2.22508 0,0 12.812219,-20.70476 13.294025,-21.48369
           0.481791,-0.77863 2.691407,-2.02849 4.303755,-2.02849
           1.612347,0 3.821948,1.24991 4.303754,2.02849 z"
   :bounding-box (bb/BoundingBox. 7.984 (- 100 7.984) 40.25 261)
   :center-fess? true

   ::name "Kalasag"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "vairy"
                  :creator-link "https://heraldicon.org/users/vairy"}})

(def ^:private community-louisiana
  {:shape "M 1.64826,87.810447 C 4.46558,85.281706 7.08513,82.261304
           7.06447,76.558245 L 6.90748,33.595381 C 6.87368,24.346329
           4.63582,22.134663 0,17.219029 4.3479,13.111909
           7.94048,8.4189856 11.55175,3.4256966 21.25678,10.980354
           40.09166,9.5735346 50,0 59.90834,9.5733441 78.74322,10.980164
           88.44825,3.4256966 92.05961,8.4189856 95.65248,13.112
           100,17.219029 c -4.63577,4.915634 -6.87367,7.1273
           -6.90748,16.376352 l -0.15699,42.962864 c -0.0208,5.703059
           2.5987,8.72332 5.41621,11.252202 C 87.51416,108.53152
           61.422,95.64892 49.99796,110 38.5758,95.64892
           12.48364,108.53128 1.64419,87.810447 z"
   :bounding-box (bb/BoundingBox. 3.5 (- 100 3.5) 8.3 101.5)
   :center-fess? true

   ::name "Louisiana"
   ::attribution {:nature :derivative
                  :license :public-domain
                  :creator-name "vairy"
                  :creator-link "https://heraldicon.org/users/vairy"
                  :source-license :public-domain
                  :source-link "https://en.wikipedia.org/wiki/File:Louisiana_state_coat_of_arms_(illustrated,_1876).jpg"
                  :source-name "Louisiana state coat of arms (illustrated, 1876)"
                  :source-creator-name "Godot13"
                  :source-creator-link "https://commons.wikimedia.org/wiki/User:Godot13"}})

(def ^:private community-french-slim
  {:shape "m 0,0 c 0,0 0,100 0,100 0,13.84023 8.933,24.42543 22.1005,25 13.1676,0.39847
           20.7982,1.73968 27.8035,13.02397 7.0052,-11.28472 14.6354,-12.62588 27.8034,-13.02397
           C 90.9714,125 100,113.84023 100,100 V 0 Z"
   :bounding-box (bb/BoundingBox. 0 100 0 125)
   :center-fess? true

   ::name "French Slim"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "vairy"
                  :creator-link "https://heraldicon.org/users/vairy"}})

(def ^:private community-innsbruck
  {:shape "M 91.010471,0.47464845 C 66.714491,-1.6621576 0.810543,2.9581254
           0,23.749 25.532311,4.7047164 29.708341,35.4882 5.304801,30.89755
           c 3.7562,2.19452 2.60989,8.7176 0.99465,22.11063 -5.305876,43.99443
           38.6147,49.50558 42.60417,68.99182 13.01009,-22.07717 49.70929,-24.11915
           51.0587,-69.15807 0.513209,-17.12945 -4.30604,-41.002575 -8.95185,-52.36728155 z"

   ::name "Innsbruck"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "vairy"
                  :creator-link "https://heraldicon.org/users/vairy"}})

(def ^:private community-heater-bulgy
  {:shape "m 50,0 c 10,0 20,0 40,5 5,30 10,52 10,70 0,30 -25,45 -50,60
           C 25,120 0,105 0,75 0,57 5,35 10,5 30,0 40,0 50,0 Z"
   :bounding-box (bb/BoundingBox. 0 100 5 135)

   ::name "Bulgy Heater"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-heater-rounded
  {:shape "m 50,0 c 30,0 50,5 50,5 v 34 c 1.6e-4,35.726721 -19.059752,68.13664 -50,86
           C 19.059752,107.13664 -1.624e-4,74.726721 0,39 V 5 C 0,5 20,0 50,0 Z"
   :bounding-box (bb/BoundingBox. 0 100 5 125)

   ::name "Rounded Heater"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-heater-pointed
  {:shape "m 50,0 c 30,5 50,5 50,5 V 39 C 99.78125,75 80.940248,107.13664 50,125 19.059752,107.13664 0,75 0,39
           V 5 C 0,5 20,5 50,0 Z"
   :bounding-box (bb/BoundingBox. 0 100 5 125)

   ::name "Pointed Heater"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-angular
  {:shape "M 0,5 50,0 100,5 95,85 50,125 5,85 z"
   :bounding-box (bb/BoundingBox. 0 100 5 125)

   ::name "Angular"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-italian-redux
  {:shape "M 50,0
           C 35,0 25,10 25,10 15,20 0,20 0,20
           c 0,55 5,64 10,70 5,6 15,20 15,30 0,30 25,30 25,30 0,0 25,0 25,-30 0,-10 10,-24 15,-30 5,-6 10,-15 10,-70 0,0 -15,0 -25,-10
           C 75,10 65,0 50,0
           Z"

   ::name "Italian Redux"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-soft-rounded
  {:shape "M 30 0
           C 15 0 0 15 0 30
             0 60 15 80 50 100
             85 80 100 60 100 30
             100 15 85 0 70 0
             55 0 45 0 30 0
           Z"
   :points {:fess (v/Vector. 50 40)}

   ::name "Soft Rounded"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-extravagant
  {:shape "M 10,85
           C 10,65 0,50 0,50 0,50 10,35 10,25 10,15 5,5 5,5
           H 15
           C 25,5 35,0 40,0 45,0 50,5 50,5 50,5 55,0 60,0 65,0 75,5 85,5
           h 10
           c 0,0 -5,10 -5,20 0,10 10,25 10,25 0,0 -10,15 -10,35 0,25 -40,35 -40,35 0,0 -40,-10 -40,-35
           z"

   ::name "Extravagant"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-philippino
  {:shape "M 35,115
           C 20,115 10,105 10,90
           V 45
           C 10,30 0,20 0,20 15,25 25,10 25,10 40,15 50,0 50,0
           c 0,0 10,15 25,10 0,0 10,15 25,10 0,0 -10,10 -10,25
           v 45
           c 0,15 -10,25 -25,25 -10,0 -15,5 -15,5 0,0 -5,-5 -15,-5
           z"
   :center-fess? true

   ::name "Filipino"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-scutum
  {:shape "M 0,15 v 130 c 0,10 30,15 50,15 20,0 50,-5 50,-15
           V 15 C 100,5 66.749793,0 50,0 30,0 0,5 0,15 z"
   :bounding-box (bb/BoundingBox. 0 100 12.5 147.5)
   :center-fess? true

   ::name "Scutum"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-american
  {:shape "M 15,0 0,15 c 0,0 10,5 10,15 0,15 -10,25 -10,50 0,15 5,30
           25,35 15,3 25,10 25,10 0,0 10,-7 25,-10 20,-5 25,-20 25,-35 C
           100,55 90,45 90,30 90,20 100,15 100,15 L 85,0 C 85,0 80,5 70,5
           55,5 50,0 50,0 50,0 45,5 30,5 20,5 15,0 15,0 z"

   ::name "American"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-triangular
  {:shape "M 50,0 C 80,0 100,10 100,10 100,60 80,90 50,120 20,90
           0,60.03607 0,10 0,10 20,0 50,0 z"
   :bounding-box (bb/BoundingBox. 0 100 10 120)
   #_#_:center-fess? true
   :points {:fess (v/Vector. 50 55)}

   ::name "Triangular"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-german
  {:shape "M 0,20 c 7,-5 20,-5 20,7 0,13 -13,13 -20,8 0,0 7,9 5,15 -2,5
           -5,15 -5,30 0,40 40,40 50,40 10,0 50,0 50,-40 C 100,65 97,55
           95,50 91,40 90,35 90,30 90,28 90,8 100,0 70,0 55,5 40,10 30,5
           25,4 15,5 0,7 0,17 0,20 z"
   :center-fess? true

   ::name "German"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-african
  {:shape "M 45,0 C 45,0 0,15 0,80 c 0,65 45,80 45,80 0,0 45,-15 45,-80 C
           90,15 45,0 45,0 z"
   :center-fess? true

   ::name "African"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-simple-kalasag
  {:shape "m 40,170
           c -10,0 -25,-2 -25,-2
           L 0,10
           C 0,10 10,4 20,3 20,3 20,15 30,25 40,15 40,1 40,1 40,1 45,0 50,0 55,0 60,1 60,1 60,1 60,15 70,25 80,15 80,3 80,3
           c 10,1 20,7 20,7
           L 85,168
           c 0,0 -15,2 -25,2 0,0 0,-10 -10,-20 -10,10 -10,20 -10,20
           z"

   ::name "Simple Kalasag"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-italian
  {:shape "M 50,0
           C 35,0 30,5 25,10
           c -10,10 -25,10 -25,10
             0,60 11.223599,65.396698 15,70
             3.776401,4.603302 14.300142,13.36702 15,35
             1.131708,34.98167 15,35 20,35
             5,0 18.868292,-0.0183 20,-35
             0.699858,-21.63298 11.223599,-30.396698 15,-35
             3.776401,-4.603302 15,-10.00006 15,-70
             0,0 -15,0 -25,-10
           C 70,5 65,0 50,0 Z"

   ::name "Italian"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-nrw
  {:shape "M 10,7 C 5,7 0,5 0,5 0,5 2,10 2,15 v 65 c 0,15 13,25 23,30 20,10
           25,15 25,15 0,0 5,-5 25,-15 10,-5 23,-15 23,-30 V 15 C 98,10 100,5
           100,5 100,5 95,7 90,7 80,7 70,0 60,0 50,0 50,5 50,5 50,5 50,0 40,0
           30,0 20,7 10,7 z"
   :bounding-box (bb/BoundingBox. 2 98 7 125)

   ::name "NRW"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-sleek-pointy
  {:shape "m 100,30
           c 0,0 0,70 -50,120
           C 0,100 0,30 0,30 35,25 50,0 50,0
           c 0,0 15,25 50,30
           z"
   :bounding-box (bb/BoundingBox. 0 100 30 150)
   :points {:fess (v/Vector. 50 75)}

   ::name "Sleek Pointy"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-french-embattled
  {:shape "M 50 125
           C 45 120 40 120 25 120
             10 120 0 120 0 110
           V 0
           H 20
           V 5
           H 40
           V 0
           H 60
           V 5
           H 80
           V 0
           h 20
           v 110
           c 0 10 -10 10 -25 10
             -15 0 -20 0 -25 5
           z"
   :bounding-box (bb/BoundingBox. 0 100 5 120)
   :points {:fess (v/Vector. 50 62.5)}

   ::name "French Embattled"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-french-engrailed
  {:shape "M 50 125
           C 45 120 40 120 25 120
             10 120 0 120 0 110
           V 0
           c 10 5 20 5 25 5
             5 0 15 0 25 -5
             10 5 20 5 25 5
             5 0 15 0 25 -5
           v 110
           c 0 10 -10 10 -25 10
             -15 0 -20 0 -25 5
           z"
   :bounding-box (bb/BoundingBox. 0 100 5 120)
   :points {:fess (v/Vector. 50 62.5)}

   ::name "French Engrailed"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-french-pointed
  {:shape "M 50 125
           C 45 120 40 120 25 120
             10 120 0 120 0 110
           V 5
           c 0 0 35 0 50 -5
             15 5 50 5 50 5
           v 105
           c 0 10 -10 10 -25 10
             -15 0 -20 0 -25 5
           z"
   :bounding-box (bb/BoundingBox. 0 100 5 120)
   :points {:fess (v/Vector. 50 62.5)}

   ::name "French Pointed"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-french-rounded
  {:shape "M 50 125
           C 45 120 40 120 25 120
             10 120 0 120 0 110
           V 5
           c 0 0 25 -5 50 -5
             25 0 50 5 50 5
           v 105
           c 0 10 -10 10 -25 10
             -15 0 -20 0 -25 5
           z"
   :bounding-box (bb/BoundingBox. 0 100 5 120)
   :points {:fess (v/Vector. 50 62.5)}

   ::name "French Rounded"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-french-mirrored
  {:shape "M 50 125
           C 45 120 40 120 25 120
             10 120 0 120 0 110
           V 15
           C 0 5 10 5 25 5
             40 5 45 5 50 0
           c 5 5 10 5 25 5
             15 0 25 0 25 10
           v 95
           c 0 10 -10 10 -25 10
             -15 0 -20 0 -25 5
           z"
   :bounding-box (bb/BoundingBox. 0 100 5 120)
   :points {:fess (v/Vector. 50 62.5)}

   ::name "French Mirrored"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-tournament
  {:shape "M 50 0
           C 40 10 25 5 25 5
             15 20 0 20 0 20
           c 25 45 10 100 10 100
             15 0 25 10 25 10
             10 -5 20 -5 30 0
             0 0 10 -10 25 -10
             0 0 -15 -55 10 -100
             0 0 -15 0 -25 -15
             0 0 -15 5 -25 -5
           z"
   :bounding-box (bb/BoundingBox. 10 90 10 120)
   :points {:fess (v/Vector. 50 65)}

   ::name "Tournament"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-rhombus
  {:shape "M 50,0 L 100,50 L 50,100 L 0,50 z"

   ::name "Rhombus"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Bananasplit1611"}})

(def ^:private community-queen-consort-modern
  {:shape "M 50,0 c 0,0 -9.494151,12.643461 -22.473589,10.987261 0,0 -4.767819,10.401769
           -27.526411,6.654218 0,0 14.196854,35.081974 3.7934578,71.435548 0,0
           16.0784912,1.395807 23.6211622,16.054983 0,0 12.815277,-3.15411
           22.58538,4.86799 9.770103,-8.0221 22.58538,-4.86799 22.58538,-4.86799
           C 80.12805,90.472834 96.206541,89.077027 96.206541,89.077027
           85.803143,52.723453 100,17.641479 100,17.641479 77.24141,21.38903
           72.473589,10.987261 72.473589,10.987261 59.494151,12.643461 50,0 50,0 z"
   :center-fess? true

   ::name "Queen Consort Modern"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Azure"}})

(def ^:private community-queen-consort
  {:shape "M 27.525575,85.776231 C 8.76938,89.100699 1.1734521,78.586662 1.3765338,69.266866
           1.7505414,52.102977 16.672696,31.57301 0,17.721581 l
           5.9022079,-6.29239 C 13.617952,12.076602 15.659962,2.0017698
           27.60419,9.4773365 33.733164,-1.4890056 44.445825,3.1114914
           49.999999,0 55.554174,3.1114914 66.266836,-1.4890056
           72.39581,9.4773365 84.340038,2.0017698 86.382048,12.076602
           94.097791,11.429191 L 100,17.721581 C 83.327303,31.57301
           98.249458,52.102977 98.623465,69.266866 98.826546,78.586662
           91.230619,89.100699 72.474424,85.776231 71.1126,96.076868
           54.053414,94.72803 49.999999,99.999996 45.946585,94.72803
           28.8874,96.076868 27.525575,85.776231 z"
   :center-fess? true

   ::name "Queen Consort"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Azure"}})

(def ^:private community-octolozenge
  {:shape "M 100,50 C 90.735009,54.857758 80.576139,71.934914 83.497312,83.456671
           72.00358,80.528445 54.967999,90.712116 50.121912,100
           45.27583,90.712116 28.240723,80.528491 16.6246,83.456671
           19.423765,71.934914 9.2649914,54.857758 0,50 9.2649914,45.142242
           19.423861,28.065088 16.502686,16.54333 27.996418,19.471604
           45.032001,9.2878843 49.999998,0 54.967999,9.2878843
           72.003104,19.471509 83.497312,16.54333 80.576184,28.065088
           90.735009,45.142242 100,50 z"
   :center-fess? true

   ::name "Octolozenge"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Azure"}})

(def ^:private community-pointy-iberian
  {:shape "m 0,0 v 65 c 0,10 5,40 30,45 20,5 20,10 20,10 0,0 0,-5 20,-10 25,-5
           30,-35 30,-45 V 0 Z"

   ::name "Pointy Iberian"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-playful
  {:shape "m 48,0 c 39.998852,0 47,8 47,8 5.00273,10 5,17 5,27 0,35.375221
           -23.877758,56.959022 -48,65 C 22.000861,90 -2.9600564e-7,74.570288
           -6.6413221e-8,40 0,30 -6.6413221e-8,20 4.9998565,10 4.9998565,10
           18.000861,0 48,0 Z"

   ::name "Playful"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-bavarian
  {:shape "m 50,0 h 50 v 85 c 0,25 -10,35 -35,35 -5,0 -25,0 -30,0 C 10,120 0,110 0,85 V 0 Z"
   :center-fess? true

   ::name "Bavarian"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-berlin
  {:shape "m 0,0 v 70 c 0,10 0.375,29 25,40 20,10 25,15 25,15 0,0 5,-5 25,-15 25,-10 25,-30 25,-40 V 0 Z"

   ::name "Berlin"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-gonfalon
  {:shape "M 100,0
           h -14.2857142857 V 10
           h -14.2857142857 V 0
           h -14.2857142857 V 10
           h -14.2857142857 V 0
           h -14.2857142857 V 10
           h -14.2857142857 V 0
           H 0 v 170 l 13,10 13,-10
           v -10 l 9,5 v 20 l 15,10 15,-10 v -20 l 9,-5 v 10 l 13,10 13,-10 z"
   :bounding-box (bb/BoundingBox. 0 100 10 160)
   :points {:fess (v/Vector. 50 85)}

   ::name "Gonfalon"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "ashoppio"
                  :creator-link "https://heraldicon.org/users/ashoppio"}})

(def ^:private community-italian-2
  {:shape "M 23.333984,0
           C 20.000655,13.259655 16.666649,23.205189 0,36.464844
           c 16.666649,23.204397 23.33333,43.092477 20,66.296876
             13.33332,0 23.333341,6.63055 30,17.23828
             6.666659,-10.60773 16.66668,-17.23828 30,-17.23828
           C 76.66667,79.557321 83.333351,59.669241 100,36.464844
             83.333351,23.205189 79.999345,13.259655 76.666016,0
             54.299346,1.5483358 37.469728,1.7076968 23.333984,0
           Z"

   ::name "Italian 2"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "ashoppio"
                  :creator-link "https://heraldicon.org/users/ashoppio"}})

(def ^:private community-flag-standard
  {:shape "m 0,0 v 30 h 90 c 0,0 10,0 10,-10 0,-9 -10,-10 -10,-10 z"
   :center-fess? true

   ::name "Standard"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-coffin
  {:shape "M 28,0 C 24.95507,0.08426855 24,3 23,5 L 2,50 c -1,2 -2.08426855,4.011223
           -2,5 0,1 0,1 1,5 l 22,95 c 1,4 2,5 4,5 h 46 c 2,0 3,-1 4,-5 L 99,60
           c 1,-4 1,-4 1,-5 0,-1 -1,-3 -2,-5 L 77,5 C 76,3 75,0 72,0 Z"
   :points {:fess (v/Vector. 50 55)}

   ::name "Coffin Shield"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-hexagonal
  {:shape "M 22,0 C 20,0 19,1 18,5 L 1,75 c -1,4 -0.97529642,4.014712 -1,5 0,1 0,1 1,5
           l 17,70 c 1,4 2,5 4,5 h 56 c 2,0 3,-1 4,-5 L 99,85
           c 1,-4 1,-4 1,-5 0,-1 0,-1 -1,-5 L 82,5 C 81,1 80,0 78,0 Z"
   :center-fess? true

   ::name "Hexagonal"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-pavise
  {:shape "M 10.529661,150 H 90 c 2,0 4.791667,0 5,-5 l 5,-120 c 0,-3 -3,-4 -5,-5 L 56,2
           C 54,1 52,0 50,0 48,0 45.992856,1.04049 44,2 L 5,20 c -2,1 -5,2 -5,5 l 5,120
           c 0.2083333,5 3,5 5.529661,5 z"
   :center-fess? true

   ::name "Pavise"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-elven
  {:shape "M 50,0 C 45,5 25.5,15 20,25
           14.5,35 5,50 0,55
           5,60 15,85 20,100
           c 5,15 25,35 30,40 5,-5 25,-25 30,-40
           C 85,85 95,60 100,55
             95,50 85.5,35 80,25
             74.5,15 55,5 50,0
           Z"
   :points {:fess (v/Vector. 50 60)}

   ::name "Elven"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-orcish
  {:shape "m 50,0 c -10,15 -20,15 -25,10 -5,5 -10,10 -25,0
           15,20 10,35 5,40 5,5 15,20 5,35 15,0 15,10 15,15
           5.26516,0.44194 14.125006,0.12502 20,20 0,-5 0,-10 5,-15
           5,5 5,10 5,15 5.874994,-19.87498 14.73484,-19.55806 20,-20
           0,-5 0,-15 15,-15 -10,-15 0,-30 5,-35
           -5,-5 -10,-20 5,-40 -15,10 -20,5 -25,0
           -5,5 -15,5 -25,-10 z"
   :bounding-box (bb/BoundingBox. 5 95 15 105)

   ::name "Orcish"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-orcish2
  {:shape "M 20,120 C 20,45 0,30 0,30 35,40 25,5 25,5 c 0,0 20,5 25,-5 0,0
           0,15 50,10 0,0 -15,10 -10,80 0,0 -15,-5 -20,10 0,0 -5,-10 -25,-10 -20,0 -25,30 -25,30 z"
   :bounding-box (bb/BoundingBox. 15 90 15 90)
   :center-fess? true

   ::name "Orcish2"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-dwarven
  {:shape "M 30,120 10,85 0,15 20,0 h 60 l 20,15 -10,70 -20,35 z"
   :bounding-box (bb/BoundingBox. 5 95 0 120)
   :points {:fess (v/Vector. 50 55)}

   ::name "Dwarven"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-gnomish
  {:shape "M 100,55 C 100,25 90,0 90,0 10,0 5,10 5,10 c 0,0 -5,15 -5,45 0,45 20,60 25,70 5,-10 75,-15 75,-70 z"
   :bounding-box (bb/BoundingBox. 0 100 5 120)

   ::name "Gnomish"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-halfling
  {:shape "M 50,125 C 20,115 0,75 0,50 0,15 15,0 50,0 c 35,0 50,15 50,50 0,25 -20,65 -50,75 z"
   :bounding-box (bb/BoundingBox. 0 100 0 125)

   ::name "Halfling"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-halfling-pavise
  {:shape "M 20,150 C 5,145 0,75 0,50 0,15 15,0 50,0 c 35,0 50,15 50,50 0,25 -5,95 -20,100 z"
   :bounding-box (bb/BoundingBox. 0 100 0 150)
   :center-fess? true

   ::name "Halfling Pavise"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-owlfolk
  {:shape "M 90,0 C 90,20 100,25 100,60 100,95 60,105 60,105 c 0,0 -5,1 -10,5 -5,-4 -10,-5 -10,-5 C 40,105 0,95 0,60 0,25 10,20 10,0 10,0 25,10 50,10 75,10 90,0 90,0 Z"
   :bounding-box (bb/BoundingBox. 5 95 5 106)
   :center-fess? true

   ::name "Owlfolk"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-arrowhead
  {:shape "m 50,5 c 30,0 45,-5 45,-5 0,0 5,10 5,40 0,30 -20,65 -50,85
           C 20,105 0,70 0,40 0,10 5,0 5,0 5,0 20,5 50,5 Z"
   :bounding-box (bb/BoundingBox. 5 95 0 125)
   :points {:fess (v/Vector. 50 50)}

   ::name "Arrowhead"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-dragonborn
  {:shape "M 30,150 C 30,150 25,95 15,85 5,75 0,80 0,80 0,80 5,70 0,60 0,60 5,50
           0,40 0,40 5,30 0,20 c 0,0 5,5 15,-5 0,0 10,-10 35,-15 25,5 35,15 35,15 10,10
           15,5 15,5 -5,10 0,20 0,20 -5,10 0,20 0,20 -5,10 0,20 0,20 0,0 -5,-5 -15,5
           -10,10 -15,65 -15,65 -10,0 -20,10 -20,10 0,0 -10,-10 -20,-10 z"
   :bounding-box (bb/BoundingBox. 0 100 0 160)

   ::name "Dragonborn"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-waisted-french
  {:shape "M 0,0.26171875
           C 5.777952,17.102504 5.076671,34.052213 0,51.257812 11.131037,106.1402 50,106.02539 50,106.02539
           c 0,0 38.868963,0.11481 50,-54.767578 -5.076671,-17.205599 -5.777952,-34.155308 0,-50.99609325
             -34.290176,2.36055605 -68.179582,2.38739475 -100,0 z"

   ::name "Waisted French"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Maximilian 'NervousNullPtr' Schleicher"
                  :creator-link "https://github.com/NervousNullPtr"}})

(def ^:private community-manilla
  {:shape "M 39,0 36.054688,10.578125
           H 26.921875
           L 25.966797,3.3671875 8.65625,2.8789062 5.646484,39.802734
           c 4.800686,1.0601 8.28711,4.250504 8.28711,8.025391 4e-6,4.114318 -4.141473,7.540667 -9.611328,8.263672
           L 0,109.12305
           H 0.01172
           C 0.00136,109.36254 0,109.59893 0,109.83984
           c 5e-6,15.96972 22.487329,28.93164 50,28.93164 27.512671,0 49.999995,-12.96192 50,-28.93164 0,-0.24091 -0.0014,-0.4773 -0.01172,-0.71679
           H 100
           L 95.677734,56.091797
           c -5.469855,-0.723005 -9.611332,-4.149354 -9.611328,-8.263672 0,-3.774887 3.486424,-6.965291 8.28711,-8.025391
           L 91.34375,2.8789062 74.033203,3.3671875 73.078125,10.578125
           H 63.945312
           L 61,0
           H 50
           Z"

   ::name "Manilla"
   ::attribution {:nature :derivative
                  :license :public-domain
                  :creator-name "verden"
                  :creator-link "https://heraldicon.org/users/verden"
                  :source-license :public-domain
                  :source-link "https://commons.wikimedia.org/wiki/File:Ph_seal_ncr_manila.svg"
                  :source-name "Ph seal ncr manila"
                  :source-creator-name "chris"
                  :source-creator-link "https://commons.wikimedia.org/wiki/User:Chrkl"}})

(def ^:private community-persian
  {:shape "M 50.010055,0
           A 50.569202,60 0 0 0 0.00414029,51.219922 7.6646945,9.5015312 0 0 1
           2.8045472,50.482031 7.6646945,9.5015312 0 0 1 10.469192,59.983594
           7.6646945,9.5015312 0 0 1 2.8045472,69.485157 7.6646945,9.5015312 0 0
           1 0,68.744727 50.569202,60 0 0 0 50.010055,120 50.569202,60 0 0 0
           99.990537,68.942579 7.6646945,9.5015312 0 0 1 97.490004,69.485157
           7.6646945,9.5015312 0 0 1 89.825359,59.983594 7.6646945,9.5015312 0 0
           1 97.490004,50.482031 7.6646945,9.5015312 0 0 1 100,51.006055
           50.569202,60 0 0 0 50.010055,0
           Z"
   :center-fess? true

   ::name "Persian"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "verden"
                  :creator-link "https://heraldicon.org/users/verden"}})

(def ^:private community-ninja
  {:shape "M 63,133
           C 63,93 80,70 100,60 95,10 70,5 50,0 30,5 5,10 0,60 20,70 37,93 37,133
           l 13,7
           z"

   ::name "Ninja"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "zalension"
                  :creator-link "https://heraldicon.org/users/zalension"}})

(def ^:private community-hawk-of-quraish
  {:shape "m 75.254067,0 23.44225,30.910845
           C 104.72775,69.977184 90.056365,108.46125 49.978884,133.94699 12.500222,110.11387 -5.1538202,73.040112 1.3096828,30.910845
           L 24.703699,0
           Z"

   ::name "Hawk of Quraish"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "natee"
                  :creator-link "https://heraldicon.org/users/natee"}})

(def ^:private community-hungarian
  {:shape "m 8.828125,0
           c 0.04144,6.0448587 -0.01953,9.8928076 -0.537109,13.744141 -0.517713,3.851333 -1.025031,6.293676 -2.734375,13.34375 3.165277,1.717042 5.466631,6.085633 5.417968,11.591797
           C 10.913509,45.59702 7.558678,53.92296 0,57.978516 5.286316,75.544164 5.859924,84.918113 12.060547,91.279297 20.793049,100.23792 42.841313,98.89524 50,110 57.158687,98.89524
             79.206498,100.23792 87.939,91.279297 94.139623,84.918113 94.713684,75.544164 100,57.978516 92.441322,53.92296 89.0861,45.59702 89.025,38.679688 88.976337,33.173524
             91.277723,28.804933 94.443,27.087891 92.733656,20.037817 92.226713,17.595474 91.709,13.744141 91.191425,9.8928076 91.13056,6.0448587 91.172,0 78.421319,2.1113109
             63.824165,3.9296875 50,3.9296875 36.175835,3.9296875 21.578806,2.1113109 8.828125,0
           Z"

   ::name "Hungarian"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "okkolol"
                  :creator-link "https://heraldicon.org/users/okkolol"}})

(def ^:private community-arabic
  {:shape "M 50,0
           C 43.625195,7.9023724 15.810991,14.122919 4.3535496,14.122919
           c -1.441231,0 -2.8095569,-0.135512 -4.25079809,-0.409076 0,0 -4.72441591,58.410374 49.89724849,98.286157
           C 104.62167,72.124217 99.897248,13.713843 99.897248,13.713843 98.456006,13.987407 97.087681,14.122919 95.64645,14.122919 84.189009,14.122919 56.374804,7.9023724 50,0
           Z"

   ::name "Arabic"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "natee"
                  :creator-link "https://heraldicon.org/users/natee"}})

(def ^:private community-engraved-german
  {:shape "M 50,0
           C 41.563938,0.07817892 31.831884,0.98081284 20.654492,2.8428472 14.407949,3.7676893 8.0744844,5.5163725 3.2061354,9.574742
           c -0.652399,0.54537 -3.12447398,3.544789 -3.20275298,4.662589 -0.08284,1.182946 1.37061298,4.1063 2.75004598,5.522284 2.17599,2.236531 4.88685,12.37852 5.346215,15.994021 0.996767,7.841146 2.3893786,20.053477 -3.55851,24.055421
           C 1.3047554,59.583073 -0.84907158,67.407632 0.60106342,74.120992 2.8854644,84.886057 5.3925394,92.740858 15.592887,99.14179
           c 1.617995,0.96576 7.2178,5.31224 7.034306,8.96727 -0.115246,2.31084 2.746521,1.64295 4.028122,-0.93962 1.185142,-2.38774 1.225192,-2.39085 2.992847,-0.23625 5.987976,7.3007 12.74609,8.33971 14.810385,9.1902 1.95865,0.80693 4.258365,2.99741 4.670271,3.49649 0.226048,0.22572 0.518445,0.35038 0.870728,0.38012
           h 9.11e-4
           c 0.352279,-0.0298 0.64468,-0.15439 0.870728,-0.38012 0.411906,-0.49908 2.711621,-2.68956 4.67027,-3.49649 2.064295,-0.85049 8.822406,-1.8895 14.810383,-9.1902 1.767654,-2.1546 1.807705,-2.15149 2.992847,0.23625 1.2816,2.58257 4.143368,3.25046 4.028122,0.93962 -0.183494,-3.65503 5.416311,-8.00151 7.034306,-8.96727 10.200347,-6.400932 12.707423,-14.255733 14.991824,-25.020798 1.450133,-6.71336 -0.703692,-14.537919 -3.94007,-14.311935 -5.947889,-4.001944 -4.555278,-16.214275 -3.55851,-24.055421 0.459365,-3.615501 3.170221,-13.75749 5.346215,-15.994021 1.379429,-1.415984 2.832888,-4.339338 2.750046,-5.522284 -0.07828,-1.1178 -2.550355,-4.117219 -3.202753,-4.662589
           C 91.925516,5.5163725 85.592051,3.7676893 79.345508,2.8428472 68.168116,0.98081284 58.436064,0.07817437 50,0
           Z"

   ::name "Engraved German"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "serindo"
                  :creator-link "https://heraldicon.org/users/serindo"}})

(def ^:private community-danish
  {:shape "M 100,0 99.067923,66.08895
           v 0.06349
           C 99.051995,78.652713 94.251107,91.14832 84.694288,100.67583 75.113583,110.22201 62.558196,114.99906 50.005151,115 37.450702,115.00053 24.896254,110.22527 15.323042,100.67583 5.7493614,91.132913 0.94846774,78.620037 0.94846774,66.104354
           L 0,0
           Z"

   ::name "Danish"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "thatoneherald"
                  :creator-link "https://heraldicon.org/users/thatoneherald"}})

(def ^:private community-herzeg-croatian
  {:shape "M 96.036226,20.636344
           C 86.218526,32.095792 90.834195,42.34861 94.106824,47.25979 110.46953,72.634244 89.270541,87.649628 72.90774,87.649628
           L 56.545033,88.46818
           c -3.272472,0 -5.726913,2.455574 -6.545023,4.911149
           C 49.181743,90.923754 46.727365,88.46818 43.454909,88.46818
           L 27.092186,87.649628
           C 10.7294,87.649628 -10.469511,72.634244 5.8931797,47.25979 9.1657307,42.34861 13.781463,32.095792 3.9638727,20.636344 8.8726597,15.725211 14.552455,9.8223927 18.643116,0 26.406548,2.0439683 38.200956,3.2727083 50.00001,3.2750863 61.826261,3.2766611 73.575661,2.0487872 81.35692,0
           c 4.090661,9.8223927 9.77044,15.725211 14.679306,20.636344
           z"

   ::name "Herzeg Croatian"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "okkolol"
                  :creator-link "https://heraldicon.org/users/okkolol"}})

(def ^:private community-croatian
  {:shape "m 112.2024,388.04533
           v 58.50666
           c 0,7.34286 -1.59693,26.29263 12.37818,34.10922 9.00092,4.9742 26.43383,3.78867 37.56656,10.6578 11.13273,-6.86913 28.56564,-5.6836 37.56657,-10.6578 13.97511,-7.81659 12.37817,-26.76636 12.37817,-34.10922
           v -58.50666
           h -42.81842 -11.86712
           z"

   ::name "Croatian"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "okkolol"
                  :creator-link "https://heraldicon.org/users/okkolol"}})

(def ^:private community-superellipse-e
  {:shape "M 300.00,200.00 L 299.87,221.77 299.47,236.21 298.80,248.73
           297.87,260.09 296.68,270.62 295.22,280.50 293.50,289.82 291.51,298.65
           289.26,307.04 286.75,315.01 283.98,322.58 280.95,329.78 277.66,336.62
           274.11,343.09 270.31,349.21 266.24,354.98 261.91,360.41 257.32,365.49
           252.46,370.22 247.34,374.60 241.94,378.65 236.25,382.34 230.28,385.68
           223.99,388.68 217.37,391.33 210.38,393.63 202.97,395.57 195.07,397.17
           186.55,398.41 177.16,399.29 166.32,399.82 150.00,400.00 133.68,399.82
           122.84,399.29 113.45,398.41 104.93,397.17 97.03,395.57 89.62,393.63
           82.63,391.33 76.01,388.68 69.72,385.68 63.75,382.34 58.06,378.65
           52.66,374.60 47.54,370.22 42.68,365.49 38.09,360.41 33.76,354.98
           29.69,349.21 25.89,343.09 22.34,336.62 19.05,329.78 16.02,322.58
           13.25,315.01 10.74,307.04 8.49,298.65 6.50,289.82 4.78,280.50
           3.32,270.62 2.13,260.09 1.20,248.73 0.53,236.21 0.13,221.77
           0.00,200.00 0.13,178.23 0.53,163.79 1.20,151.27 2.13,139.91
           3.32,129.38 4.78,119.50 6.50,110.18 8.49,101.35 10.74,92.96
           13.25,84.99 16.02,77.42 19.05,70.22 22.34,63.38 25.89,56.91
           29.69,50.79 33.76,45.02 38.09,39.59 42.68,34.51 47.54,29.78
           52.66,25.40 58.06,21.35 63.75,17.66 69.72,14.32 76.01,11.32
           82.63,8.67 89.62,6.37 97.03,4.43 104.93,2.83 113.45,1.59 122.84,0.71
           133.68,0.18 150.00,0.00 166.32,0.18 177.16,0.71 186.55,1.59
           195.07,2.83 202.97,4.43 210.38,6.37 217.37,8.67 223.99,11.32
           230.28,14.32 236.25,17.66 241.94,21.35 247.34,25.40 252.46,29.78
           257.32,34.51 261.91,39.59 266.24,45.02 270.31,50.79 274.11,56.91
           277.66,63.38 280.95,70.22 283.98,77.42 286.75,84.99 289.26,92.96
           291.51,101.35 293.50,110.18 295.22,119.50 296.68,129.38 297.87,139.91
           298.80,151.27 299.47,163.79 299.87,178.23 300.00,200.00 Z"

   :center-fess? true

   ::name "Superellipse (3x4, curvature e)"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "pseudomonas"
                  :creator-link "https://heraldicon.org/users/pseudomonas"}})

(def ^:private community-superellipse-4
  {:shape "M 300.00,200.00 L 299.91,244.30 299.64,262.62 299.19,276.61
           298.55,288.34 297.74,298.59 296.73,307.76 295.55,316.08 294.18,323.72
           292.62,330.78 290.87,337.32 288.92,343.40 286.78,349.07 284.43,354.36
           281.88,359.30 279.12,363.90 276.13,368.18 272.92,372.16 269.47,375.84
           265.77,379.24 261.80,382.37 257.55,385.23 252.99,387.82 248.08,390.16
           242.79,392.24 237.06,394.07 230.82,395.65 223.94,396.98 216.25,398.07
           207.46,398.91 196.96,399.52 183.23,399.88 150.00,400.00 116.77,399.88
           103.04,399.52 92.54,398.91 83.75,398.07 76.06,396.98 69.18,395.65
           62.94,394.07 57.21,392.24 51.92,390.16 47.01,387.82 42.45,385.23
           38.20,382.37 34.23,379.24 30.53,375.84 27.08,372.16 23.87,368.18
           20.88,363.90 18.12,359.30 15.57,354.36 13.22,349.07 11.08,343.40
           9.13,337.32 7.38,330.78 5.82,323.72 4.45,316.08 3.27,307.76
           2.26,298.59 1.45,288.34 0.81,276.61 0.36,262.62 0.09,244.30
           0.00,200.00 0.09,155.70 0.36,137.38 0.81,123.39 1.45,111.66
           2.26,101.41 3.27,92.24 4.45,83.92 5.82,76.28 7.38,69.22 9.13,62.68
           11.08,56.60 13.22,50.93 15.57,45.64 18.12,40.70 20.88,36.10
           23.87,31.82 27.08,27.84 30.53,24.16 34.23,20.76 38.20,17.63
           42.45,14.77 47.01,12.18 51.92,9.84 57.21,7.76 62.94,5.93 69.18,4.35
           76.06,3.02 83.75,1.93 92.54,1.09 103.04,0.48 116.77,0.12 150.00,0.00
           183.23,0.12 196.96,0.48 207.46,1.09 216.25,1.93 223.94,3.02
           230.82,4.35 237.06,5.93 242.79,7.76 248.08,9.84 252.99,12.18
           257.55,14.77 261.80,17.63 265.77,20.76 269.47,24.16 272.92,27.84
           276.13,31.82 279.12,36.10 281.88,40.70 284.43,45.64 286.78,50.93
           288.92,56.60 290.87,62.68 292.62,69.22 294.18,76.28 295.55,83.92
           296.73,92.24 297.74,101.41 298.55,111.66 299.19,123.39 299.64,137.38
           299.91,155.70 300.00,200.00 Z"

   :center-fess? true

   ::name "Superellipse (3x4, curvature 4)"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "pseudomonas"
                  :creator-link "https://heraldicon.org/users/pseudomonas"}})

(def ^:private community-pennant
  {:shape "M 0,0
           V 50
           C 0,50 100,25 100,25
           Z"

   ::name "Pennant"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-demipennant
  {:shape "M 0,0
           V 50
           H 35
           L 100,25 35,0
           Z"

   ::name "Demipennant"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-rounded-pennant
  {:shape "M 0,0
           V 50
           C 0,50 85,40 100,25 85,10 0,0 0,0
           Z"

   ::name "Rounded Pennant"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-dovetailed-standard
  {:shape "m 0,0
           v 30
           h 90
           c 0,0 10,-1 10,-5 0,-3 -3,-4 -5,-5 2,-1 5,-2 5,-5 0,-4 -10,-5 -10,-5
           z"

   ::name "Dovetailed Standard"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-chevron-gonfalon
  {:shape "M 0,0
           H 100
           V 130
           L 50,180 0,130
           Z"

   ::name "Chevron Gonfalon"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-dovetailed-gonfalon
  {:shape "M 0,0
           H 100
           V 180
           L 50,130 0,180
           Z"

   ::name "Dovetailed Gonfalon"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-oval-gonfalon
  {:shape "m 0,0
           h 100
           v 100
           c 0,25 -25,65 -50,80
           C 25,165 0,125 0,100
           Z"

   ::name "Oval Gonfalon"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-rounded-gonfalon
  {:shape "m 0,0
           h 100
           v 140
           c 0,5 -5,10 -15,10 -10,0 -15,-5 -15,-5 0,5 -5,15 -20,15 -15,0 -20,-10 -20,-15 0,0 -5,5 -15,5
           C 5,150 0,145 0,140
           Z"

   ::name "Rounded Gonfalon"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-draped-pointy-banner
  {:shape "M 0,0
           H 300
           V 284
           L 263,341 226,284 150,390 74,284 37,341 0,284
           Z"

   :bounding-box (bb/BoundingBox. 0 300 0 284)

   ::name "Draped Pointy Banner"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "verden"
                  :creator-link "https://heraldicon.org/users/verden"}})

(def ^:private community-embattled-heater
  {:shape "M 50,125
           C 7,108 5,80 5,80
           L 0,0
           h 20
           l 1,5
           H 39
           V 0
           h 22
           v 5
           h 18
           l 1,-5
           h 20
           l -5,80
           c 0,0 -2,28 -45,45
           z"

   :bounding-box (bb/BoundingBox. 0 100 5 100)
   :points {:fess (v/Vector. 50 55)}

   ::name "Embattled Heater"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-embattled-iberian
  {:shape "M 50,125
           C 7,125 5,80 5,80
           L 0,0
           h 20
           l 1,5
           H 39
           V 0
           h 22
           v 5
           h 18
           l 1,-5
           h 20
           l -5,80
           c 0,0 -2,45 -45,45
           z"

   :bounding-box (bb/BoundingBox. 0 100 5 125)
   :points {:fess (v/Vector. 50 55)}

   ::name "Embattled Iberian"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "Korfi2Go"
                  :creator-link "https://heraldicon.org/users/korfi2go"}})

(def ^:private community-pauldron
  {:shape "M 0,79.5
           C 0,-26.5 100,-26.5 100,79.5
           Z"

   :bounding-box (bb/BoundingBox. 0 100 0 79.5)
   :points {:fess (v/Vector. 50 39.75)}

   ::name "Pauldron"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "jipowap"
                  :creator-link "https://heraldicon.org/users/jipowap"}})

(def ^:private community-american-highway
  {:shape "m 49.363758 98.111999
           c -1.027292 -0.89245 -3.24 -2.305094 -4.942014 -3.155099
             -3.091778 -1.544071 -6.350111 -2.423204 -9.938082 -2.681397
             -1.11366 -0.08014 -2.944043 -0.211285 -4.067516 -0.291432
           C 25.405808 91.626634 18.485655 90.260068 15.53285 89.044976
             11.386347 87.33867 7.3781419 84.139489 4.7449265 80.434507
             2.9055565 77.84648 1.3923396 74.343701 0.66948509 71.000718
             0.38916346 69.704316 0.34901161 69.112462 0.34454685 66.210988
             0.3404326 63.53698 0.38847416 62.670199 0.59440525 61.703005
             1.3520815 58.144437 2.4054846 55.548575 4.2281703 52.748451
             6.8301633 48.751104 8.3243591 44.998764 9.0777243 40.569875
             9.4409226 38.434703 9.509327 34.38729 9.2205444 32.119373
             8.3642737 25.394757 5.4787484 19.422456 0.67855535 14.439631
           L 0 13.735259
             7.7570452 6.8864778
             15.514091 0.03769768
             16.85883 0.88288331
           c 3.462582 2.17627539 7.597597 3.66897129 11.823849 4.26828129
             2.022684 0.2868297 5.979498 0.2821039 8.048522 -0.00961
           C 40.990122 4.541076 45.647236 2.8093156 49.010204 0.57557032
             49.4868 0.25900661 49.933471 0 50.002806 0
           c 0.06934 0 0.651243 0.34112549 1.293128 0.75805663
             3.418362 2.22037307 7.673893 3.77376337 12.030665 4.39153657
             2.03618 0.2887223 5.984811 0.2845021 8.063849 -0.00862
           C 75.573905 4.5511558 79.742399 3.02943 83.264644 0.80625122
           L 84.48266 0.03746104
             92.241331 6.8860401
             100 13.734619
             99.319138 14.43931
           c -3.806567 3.939791 -6.461161 8.606155 -7.769407 13.657413
             -0.792917 3.061533 -0.899142 3.961731 -0.898579 7.614949
             5.68e-4 3.601793 0.128142 4.75194 0.83762 7.550813
             0.805698 3.178456 2.226756 6.352838 4.155979 9.283682
             1.855008 2.818095 2.971011 5.488261 3.679932 8.804652
             0.29559 1.382793 0.330702 1.906021 0.326156 4.860169
             -0.0045 2.901474 -0.04462 3.493328 -0.324938 4.78973
             -0.480331 2.221386 -1.188835 4.231165 -2.20997 6.268912
             -1.164522 2.323883 -2.421448 4.091248 -4.292408 6.035553
             -3.195839 3.321118 -6.925098 5.545722 -11.133208 6.641254
             -3.832444 0.997731 -8.468964 1.777806 -12.111074 2.037634
             -1.123474 0.08015 -2.942878 0.210373 -4.043119 0.289389
             -5.287335 0.379716 -9.949528 2.111166 -14.101665 5.23709
             -0.804757 0.605856 -1.473096 1.099176 -1.485197 1.096269
             -0.01211 -0.0029 -0.275579 -0.225578 -0.585502 -0.49482
           z"

   ::name "American Highway"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "okkolol"
                  :creator-link "https://heraldicon.org/users/okkolol"}})

(def ^:private community-interstate
  {:shape "M 13.43659 -4.9e-4
         C 5.023121 10.63309 0 24.072402 0 38.685034
           0 68.872076 21.435953 94.051895 49.916805 99.833121
           78.397657 94.051895 99.83361 68.872076 99.83361 38.685034
           99.83361 24.072402 94.810489 10.63309 86.39702 -4.9e-4
           80.62734 1.7604938 74.503838 2.7078867 68.157888 2.7078867
         c -6.34587 0 -12.471403 -0.9474741 -18.241083 -2.7083767
           -5.76968 1.7609026 -11.895213 2.7083767 -18.241083 2.7083767
           -6.34595 0 -12.469452 -0.9473929 -18.239132 -2.7083767
         z"

   ::name "Interstate"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "okkolol"
                  :creator-link "https://heraldicon.org/users/okkolol"}})

(def ^:private community-croatian-engrailed
  {:shape "M 0 0
           C 0.01888033 21.321615 0.03776067 42.643229 0.056641 63.964844
             2.2091777 77.166454 9.8405608 89.503663 21.478616 96.360275
             30.388439 101.99563 40.479874 105.27044 50 109.66992
             64.611518 103.01969 81.464544 98.26866 91.382321 84.675717
             95.975568 78.271708 99.134669 70.62288 99.94441 62.777511
             99.96294 41.851674 99.98147 20.925837 100 0
             85.389489 9.831217 64.359426 10.896922 50 0
             35.647494 10.919317 14.606934 9.8078449 0 0
           Z"

   :bounding-box (bb/BoundingBox. 0 100 7.6 109.67)

   ::name "Croatian Engrailed"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "okkolol"
                  :creator-link "https://heraldicon.org/users/okkolol"}})

(def ^:private community-georgian
  {:shape "m 0 0
           v 107.11045
           c 0 11.98579 5.9112549 13.59526 14.813962 13.76242
             4.020165 0.0401 14.854906 -0.097 18.230207 -0.0655
             9.129178 0.0836 13.91704 4.30084 16.95583 11.41943
             3.038793 -7.11859 7.827292 -11.33584 16.956473 -11.41943
             3.375296 -0.0314 14.21004 0.10565 18.229562 0.0655
           C 94.089385 120.70571 100 119.09624 100 107.11045
           V 0
           Z"

   :bounding-box (bb/BoundingBox. 0 100 0 120.807)
   :points {:fess (v/Vector. 50 60.4035)}

   ::name "Georgian"
   ::attribution {:nature :own-work
                  :license :public-domain
                  :creator-name "okkolol"
                  :creator-link "https://heraldicon.org/users/okkolol"}})

(def ^:private escutcheons
  [[:string.escutcheon.group/traditional
    [:heater heater]
    [:community-heater-pointed community-heater-pointed]
    [:community-heater-rounded community-heater-rounded]
    [:square-french square-french]
    [:square-iberian square-iberian]
    [:square-czech square-czech]
    [:french-modern french-modern]
    [:english english]
    [:kite kite]
    [:norman-rounded norman-rounded]
    [:norman norman]]
   [:string.escutcheon.group/shapes
    [:rectangle rectangle]
    [:lozenge lozenge]
    [:community-rhombus community-rhombus]
    [:roundel roundel]
    [:oval oval]
    [:community-superellipse-e community-superellipse-e]
    [:community-superellipse-4 community-superellipse-4]]
   [:string.escutcheon.group/flags
    [:flag flag]
    [:community-flag-standard community-flag-standard]
    [:community-dovetailed-standard community-dovetailed-standard]
    [:community-pennant community-pennant]
    [:community-demipennant community-demipennant]
    [:community-rounded-pennant community-rounded-pennant]]
   [:string.escutcheon.group/decorative
    [:wedge wedge]
    [:swiss swiss]
    [:community-arrowhead community-arrowhead]
    [:community-nrw community-nrw]
    [:renaissance renaissance]
    [:polish polish]
    [:polish-19th-century polish-19th-century]
    [:community-american community-american]]
   [:string.escutcheon.group/community
    [:community-square-iberian-engrailed community-square-iberian-engrailed]
    [:community-pointy-iberian community-pointy-iberian]
    [:community-pointy-iberian-engrailed community-pointy-iberian-engrailed]
    [:community-berlin community-berlin]
    [:community-angular community-angular]
    [:community-waisted-french community-waisted-french]
    [:community-triangular community-triangular]
    [:community-sleek-pointy community-sleek-pointy]
    [:community-heater-bulgy community-heater-bulgy]
    [:community-bavarian community-bavarian]
    [:community-french-slim community-french-slim]
    [:community-french-embattled community-french-embattled]
    [:community-french-engrailed community-french-engrailed]
    [:community-french-rounded community-french-rounded]
    [:community-french-pointed community-french-pointed]
    [:community-french-mirrored community-french-mirrored]
    [:community-german community-german]
    [:community-innsbruck community-innsbruck]
    [:community-italian community-italian]
    [:community-italian-redux community-italian-redux]
    [:community-italian-2 community-italian-2]
    [:community-coffin community-coffin]
    [:community-hexagonal community-hexagonal]
    [:community-pavise community-pavise]
    [:community-scutum community-scutum]
    [:community-louisiana community-louisiana]
    [:community-queen-consort community-queen-consort]
    [:community-queen-consort-modern community-queen-consort-modern]
    [:community-octolozenge community-octolozenge]
    [:community-ninja community-ninja]
    [:community-dragonborn community-dragonborn]
    [:community-dwarven community-dwarven]
    [:community-elven community-elven]
    [:community-orcish community-orcish]
    [:community-orcish2 community-orcish2]
    [:community-owlfolk community-owlfolk]
    [:community-gnomish community-gnomish]
    [:community-halfling community-halfling]
    [:community-halfling-pavise community-halfling-pavise]
    [:community-african community-african]
    [:community-hawk-of-quraisch community-hawk-of-quraish]
    [:community-extravagant community-extravagant]
    [:community-philippino community-philippino]
    [:community-engraved-german community-engraved-german]
    [:community-hungarian community-hungarian]
    [:community-playful community-playful]
    [:community-soft-rounded community-soft-rounded]
    [:community-danish community-danish]
    [:community-croatian community-croatian]
    [:community-interstate community-interstate]
    [:community-american-highway community-american-highway]
    [:community-herzeg-croatian community-herzeg-croatian]
    [:community-croatian-engrailed community-croatian-engrailed]
    [:community-georgian community-georgian]
    [:community-embattled-heater community-embattled-heater]
    [:community-embattled-iberian community-embattled-iberian]
    [:community-pauldron community-pauldron]
    [:community-persian community-persian]
    [:community-arabic community-arabic]
    [:community-tournament community-tournament]
    [:community-draped-pointy-banner community-draped-pointy-banner]
    [:community-oval-gonfalon community-oval-gonfalon]
    [:community-chevron-gonfalon community-chevron-gonfalon]
    [:community-dovetailed-gonfalon community-dovetailed-gonfalon]
    [:community-rounded-gonfalon community-rounded-gonfalon]
    [:community-gonfalon community-gonfalon]
    [:community-manilla community-manilla]
    [:community-simple-kalasag community-simple-kalasag]
    [:community-kalasag community-kalasag]]])

(def ^:private kinds-map
  (into {}
        (for [[_ & items] escutcheons
              [key value] items]
          [key value])))

(def choices
  (into [[:string.escutcheon.type/none
          [:string.escutcheon.type/none :none]]]
        (map (fn [[group-name & items]]
               (into [group-name]
                     (map (fn [[key data]]
                            [(::name data) key]))
                     items)))
        escutcheons))

(def escutcheon-map
  (options/choices->map choices))

(defn attribution [escutcheon]
  (let [{::keys [attribution name]} (get kinds-map escutcheon)]
    (assoc attribution :name name)))

(defn data [escutcheon-type flag-width flag-height swallow-tail tail-point-height tail-tongue]
  (let [escutcheon-data (get kinds-map escutcheon-type)
        {:keys [bounding-box
                points
                shape
                center-fess?]} (if (= escutcheon-type :flag)
                                 ((:function escutcheon-data) flag-width flag-height swallow-tail tail-point-height tail-tongue)
                                 escutcheon-data)
        bounding-box (or bounding-box (bb/from-paths [shape]))
        points (cond-> points
                 center-fess? (assoc :fess (bb/center bounding-box)))]
    {:shape shape
     :bounding-box bounding-box
     :environment (environment/create bounding-box points :root? true)}))

(defn transform-to-width [{:keys [shape environment]} target-width]
  (let [width (:width environment)
        original-shape-bounding-box (bb/from-paths [shape])
        top-left-shape (bb/top-left original-shape-bounding-box)
        effective-offset (v/sub top-left-shape)
        scale-factor (/ target-width width)
        transform-bb (fn [bb]
                       (-> bb
                           (bb/translate effective-offset)
                           (bb/scale scale-factor)))
        transformed-shape (-> shape
                              path/parse-path
                              (path/translate (:x effective-offset) (:y effective-offset))
                              (path/scale scale-factor scale-factor)
                              path/to-svg)
        shape-bounding-box (bb/from-paths [transformed-shape])]
    {:shape transformed-shape
     :shape-bounding-box shape-bounding-box
     :environment (-> environment
                      (update :width * scale-factor)
                      (update :height * scale-factor)
                      (update :points (fn [points]
                                        (into {}
                                              (map (fn [[key value]]
                                                     [key (-> value
                                                              (v/add effective-offset)
                                                              (v/mul scale-factor))]))
                                              points)))
                      (update :bounding-box transform-bb))}))

(def flag-options
  {:flag-aspect-ratio-preset {:type :option.type/choice
                              :choices [[(string/str-tr "--- " :string.escutcheon.type/select-ratio " ---") :none]
                                        ["2:3 (most common)" :preset-2-3]
                                        ["1:2 (common)" :preset-1-2]
                                        ["3:5 (common)" :preset-3-5]
                                        ["1:1" :preset-1-1]
                                        ["3:4" :preset-3-4]
                                        ["4:3" :preset-4-3]
                                        ["4:5" :preset-4-5]
                                        ["4:7" :preset-4-7]
                                        ["5:7" :preset-5-7]
                                        ["5:8" :preset-5-8]
                                        ["6:7" :preset-6-7]
                                        ["6:13" :preset-6-13]
                                        ["7:10" :preset-7-10]
                                        ["7:11" :preset-7-11]
                                        ["7:13" :preset-7-13]
                                        ["7:17" :preset-7-17]
                                        ["8:11" :preset-8-11]
                                        ["9:16" :preset-9-16]
                                        ["10:17" :preset-10-17]
                                        ["10:19" :preset-10-19]
                                        ["11:18" :preset-11-18]
                                        ["11:19" :preset-11-19]
                                        ["11:20" :preset-11-20]
                                        ["11:28" :preset-11-28]
                                        ["13:15" :preset-13-15]
                                        ["15:22" :preset-15-22]
                                        ["16:25" :preset-16-25]
                                        ["16:27" :preset-16-27]
                                        ["17:26" :preset-17-26]
                                        ["18:25" :preset-18-25]
                                        ["19:36" :preset-19-36]
                                        ["22:41" :preset-22-41]
                                        ["28:37" :preset-28-37]]
                              :ui/label :string.option/aspect-ratio-preset
                              :ui/element :ui.element/flag-aspect-ratio-preset-select}

   :flag-width {:type :option.type/range
                :default 3
                :min 0.1
                :max 41
                :ui/label :string.option/flag-width
                :ui/step 0.01}

   :flag-height {:type :option.type/range
                 :default 2
                 :min 0.1
                 :max 41
                 :ui/label :string.option/flag-height
                 :ui/step 0.01}

   :flag-swallow-tail {:type :option.type/range
                       :default 0
                       :min 0
                       :max 100
                       :ui/label :string.option/flag-swallow-tail
                       :ui/step 0.01}

   :flag-tail-point-height {:type :option.type/range
                            :default 0
                            :min 0
                            :max 90
                            :ui/label :string.option/flag-tail-point-height
                            :ui/step 0.01}

   :flag-tail-tongue {:type :option.type/range
                      :default 0
                      :min 0
                      :max 100
                      :ui/label :string.option/flag-tongue
                      :ui/step 0.01}})
